import axios from 'axios';

// In production the SPA is served by the backend (same origin), so a relative
// baseURL works automatically behind the reverse proxy. In development, CRA's
// "proxy" setting forwards /api to the backend on :8000.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

// Attach the stored token to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
